import { useMutation } from 'react-query';
import { useToastContext } from 'shared/components/Toast/context/ToastContext';
import { userService } from 'shared/services/UserService';

export const useDeleteUser = () => {
    const { showToast } = useToastContext();

    const { mutateAsync, isError, isLoading } = useMutation(
        (userID: number) => {
            return userService.deleteUser(userID);
        },
        {
            onSuccess: () => {
                showToast('success', 'User deleted');
            },
            onError: (error: any) => {
                console.log('Error on posting procedure - ');
                showToast('error', error?.detail);
            },
        }
    );

    return {
        mutateAsync,
        isLoading,
        serverErrorMessage: isError,
    };
};
